module.exports = __webpack_public_path__ + "img/32708094000144.93df8b6c.png";